import ApiBase from '../apiClients/base/ApiBase'
import { ProficiencyType } from '../models/dtos';
import { MarketplaceDisplay } from '../models/custom-models';
import { ProficiencyGroupType } from '../Enums';
import { IsNotEmpty } from '../Helpers';

class MarketplaceClient extends ApiBase {
    private controllerName: string = 'Marketplace';

    async Upload(context: UploadTemplateContext, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}/upload`, context, signal);
    }

    async Install(context: InstallTemplateContext, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}/install`, context, signal);
    }

    async GetTemplatesFiltered(tagsToFilter?: string, signal?: AbortSignal): Promise<MarketplaceDisplay[]> {
        let url = `${this.controllerName}`;
        if (IsNotEmpty(tagsToFilter))
            url += `?tagsToFilter=${tagsToFilter}`;

        return this.GetAsync(url, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<MarketplaceTemplateDetail> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

}

 export interface UploadTemplateContext {
    TemplateRevisionId: string;
    ShortDescription: string;
    DetailedDescription: string;
    Tags: string;
    Price: number;
}

export interface InstallTemplateContext {
    MarketplaceTemplateId: string;
    TemplateName: string;
    PositionId: string;
}

export interface TemplateMetadata {
    Id: string;
    OrganizationId: string;
    OriginTemplateName: string;
    OriginPositionId: string;
    Shortdescription: string;
    DetailedDescription: string;
    Tags: string;
    Price: number;
    IsActive: boolean;
    IsDeleted: boolean;
    LastUpdateDate: string;
}

export interface MarketplaceTemplateRevision {
    Id: string;
    TemplateMetadataId: string;
    Revision: number;
    IsActive: boolean;
    IsDeleted: boolean;
    LastUpdateDate: string;
}

export interface MarketplaceProficiency {
    Id: string;
    TemplateRevisionId: string;
    Name: string;
    Type: ProficiencyType;
    ProficiencyGroupType: ProficiencyGroupType;
    ParentProficiencyId: string;
    Notes: string;
    Weight: number;
    IsNegative: boolean;
    IsDeleted: boolean;
    LastUpdateDate: string;
}

export interface MarketplaceTemplateDetail {
    TemplateMetadata: TemplateMetadata;
    MarketplaceTemplateRevision: MarketplaceTemplateRevision;
    MarketplaceProficiency: MarketplaceProficiency[];
}

export enum MarketplaceErrors {
    Install = 'Error intalling Martketplace Template',
    GetAll = 'Error loading Marketplace Templates',
    GetSingle = 'Error loading Marketplace Template',
    Upload = 'Error uploading Template',

}

export default MarketplaceClient;